{
  "en": {
    "ticket_category": {
      "Decisions": "Decision",
      "Issue": "Aftercare",
      "Regular": "Regular",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
